import React from 'react';
import WhatWeDoPage from 'templates/whatWeDo';


const App = () => (
  <WhatWeDoPage />
);

export default App;
